/**
 * Safe storage wrapper with Electron fallback
 * Provides a consistent interface for localStorage access across environments
 * Automatically handles Electron storage API when available
 */
const safeStorage = {
  getItem: (key) => {
    try {
      if (window.electronAPI && window.electronAPI.storage) {
        return window.electronAPI.storage.getItem(key);
      }
      return localStorage.getItem(key);
    } catch (error) {
      console.warn('Storage access failed:', error);
      return null;
    }
  },
  
  setItem: (key, value) => {
    try {
      if (window.electronAPI && window.electronAPI.storage) {
        return window.electronAPI.storage.setItem(key, value);
      }
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.warn('Storage write failed:', error);
      return false;
    }
  },
  
  removeItem: (key) => {
    try {
      if (window.electronAPI && window.electronAPI.storage) {
        return window.electronAPI.storage.removeItem(key);
      }
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.warn('Storage remove failed:', error);
      return false;
    }
  },
  
  clear: () => {
    try {
      if (window.electronAPI && window.electronAPI.storage) {
        return window.electronAPI.storage.clear();
      }
      localStorage.clear();
      return true;
    } catch (error) {
      console.warn('Storage clear failed:', error);
      return false;
    }
  },
  
  key: (index) => {
    try {
      if (window.electronAPI && window.electronAPI.storage) {
        return window.electronAPI.storage.key(index);
      }
      return localStorage.key(index);
    } catch (error) {
      console.warn('Storage key access failed:', error);
      return null;
    }
  },
  
  get length() {
    try {
      if (window.electronAPI && window.electronAPI.storage) {
        return window.electronAPI.storage.length;
      }
      return localStorage.length;
    } catch (error) {
      console.warn('Storage length access failed:', error);
      return 0;
    }
  }
};

export default safeStorage;
